import { isWhatsappExtensionContext } from './detect-context';

/**
 * #764 — thrown by a content→page command when this window has no WhatsApp page bridge to
 * answer it (the standalone web app bundles the same code). Rejecting at once replaces a 10s
 * wait that always ended in a timeout and a bogus bridge_timeout report.
 */
export class NoPageBridgeError extends Error {
  public readonly code = 'no_page_bridge' as const;

  constructor(public readonly cmd: string) {
    super(`[no_page_bridge] cmd ${cmd} needs the WhatsApp page; this window has none`);
    this.name = 'NoPageBridgeError';
  }
}

export function isNoPageBridgeError(error: unknown): error is NoPageBridgeError {
  return error instanceof NoPageBridgeError;
}

/** Throw NoPageBridgeError unless this window is the WhatsApp page (where the page bridge lives). */
export function assertWaPageBridge(cmd: string): void {
  if (!isWhatsappExtensionContext()) throw new NoPageBridgeError(cmd);
}
